document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product__vendor .vendor-link').forEach(function (a) {
    try {
      var href = a.getAttribute('href') || '';
      if (href.indexOf('/search') === -1 && href.indexOf('?q=') === -1) return; // only replace search-based links

      var vendor = a.dataset.vendor || a.textContent || '';
      vendor = vendor.trim();
      if (!vendor) return;

      // approximate Shopify `handle` filter in JS
      var handle = vendor
        .toLowerCase()
        .normalize && vendor.normalize('NFKD').replace(/\p{Diacritic}/gu, '') || vendor.toLowerCase();
      handle = handle.replace(/[^a-z0-9\s-]/gi, '');
      handle = handle.trim().replace(/\s+/g, '-');

      a.setAttribute('href', '/collections/' + handle);
    } catch (e) {
      // fail quietly
      console.error('vendor-link-fix error', e);
    }
  });
});
